import { Navigate, useLocation } from 'react-router-dom';
import { mapLegacyProductionPath } from '../constants/productionRouteMap';

/** 旧 /my-plant-protection/* 路径重定向到 canonical /production/* */
export default function LegacyProductionRedirect() {
  const location = useLocation();
  const target = mapLegacyProductionPath(location.pathname, location.search);
  return <Navigate to={target} replace />;
}
